import React, { Component } from "react";

const Parallax = () => (
  <div className="row">
    <div className="col s1 m3 l3" />
    <div className="col s10 m6 l6">
      <img
        src="http://www.clker.com/cliparts/q/h/b/e/B/b/gradient-wave-hi.png"
        className="responsive-img"
        alt=""
      />
    </div>
    <div className="col s1 m3 l3" />
  </div>
);

export default Parallax;
